import { Component, Input } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpTicketService } from '../../../service/http-ticket.service';
import { AgentDto, TicketDto } from '../../../service/dto';

@Component({
	selector: 'app-ticket-assign-modal',
	standalone: false,
	templateUrl: './ticket-assign-modal.component.html',
	styleUrl: './ticket-assign-modal.component.scss'
})
export class TicketAssignModalComponent {
	@Input() agents: AgentDto[] = [];
	@Input() ticket!: TicketDto;

	selectedAgent?: AgentDto;
	loading = false;

	constructor(private modalRef: NzModalRef, private ticketService: HttpTicketService, private message: NzMessageService) { }

	handleOk(): void {
		if (!this.selectedAgent) {
			this.message.warning('Please select an agent');
			return;
		}

		this.loading = true;

		this.ticketService.assignTicketToAgent(this.ticket, this.selectedAgent).subscribe({
			next: () => {
				this.loading = false;
				this.message.success('Ticket assigned successfully');
				this.modalRef.close(true);
				this.ticket.assignedToAgent=this.selectedAgent;
			},
			error: (err) => {
				this.loading = false;
				this.message.error('Failed to assign ticket');
				console.error(err);
			}
		});
	}

	handleCancel(): void {
		this.modalRef.close(false);
	}
}
